import React, { useEffect, useState } from 'react';
import Loginfooter from '../../common/Loginfooter';
import { useForm } from 'react-hook-form';
import axios from 'axios';
import { useNavigate } from 'react-router';
import Loader from '../../common/Loader';
import { Link } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import { useDispatch } from 'react-redux';
import { dispatchMmvData } from '../../store/actions/userActions';
import { toast } from 'react-toastify';

const ForgotPassword = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // =========================================================
  // API URL
  // =========================================================

  const ForgetUrl =
    'https://uatmasterapi.flaskitsolutions.com';

  // =========================================================
  // COOKIES
  // =========================================================

  const [cookies, setCookie] = useCookies([
    'token',
    'email',
  ]);

  // =========================================================
  // STATES
  // =========================================================

  const [loading, setLoading] = useState(false);
  const [showFields, setShowFields] = useState(false);

  // =========================================================
  // FORM
  // =========================================================

  const {
    register,
    handleSubmit,
    watch,
    trigger,
    getValues,
    formState: { errors },
  } = useForm({
    mode: 'onBlur',
  });

  const newPassword = watch('newPassword');

  // =========================================================
  // SET API URL IN REDUX
  // =========================================================

  useEffect(() => {
    dispatchMmvData('apiUrl', ForgetUrl);
  }, [dispatch]);

  // =========================================================
  // FORGOT PASSWORD
  // IMPORTANT:
  // Direct axios call
  // NO PostDataWithToken
  // NO ACCESS TOKEN
  // NO REFRESH TOKEN
  // =========================================================

  const handleForget = async () => {
    try {
      // ---------------------------------------------
      // Validate Email
      // ---------------------------------------------

      const isValid = await trigger('email');

      if (!isValid) {
        return;
      }

      const email = getValues('email');

      if (!email) {
        toast.error('Please enter email');
        return;
      }

      setLoading(true);

      const payload = {
        email: email.trim(),
      };

      console.log(
        'FORGOT PASSWORD PAYLOAD:',
        payload
      );

      console.log(
        'FORGOT PASSWORD URL:',
        `${ForgetUrl}/login-panel/forgotPassword`
      );

      // =================================================
      // DIRECT AXIOS CALL
      // This completely bypasses your auth interceptor
      // =================================================

      const response = await axios.post(
        `${ForgetUrl}/login-panel/forgotPassword`,
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
            'X-localization': 'en',
          },
          timeout: 30000,
        }
      );

      console.log(
        'FORGOT PASSWORD RESPONSE:',
        response
      );

      const result = response?.data;

      // =================================================
      // SUCCESS
      // =================================================

      if (result?.success || result?.status) {
        // ---------------------------------------------
        // Save token if backend sends token
        // ---------------------------------------------

        if (result?.token) {
          setCookie('token', result.token, {
            path: '/',
          });
        }

        if (result?.data?.token) {
          setCookie(
            'token',
            result.data.token,
            {
              path: '/',
            }
          );
        }

        // ---------------------------------------------
        // Save Email
        // ---------------------------------------------

        setCookie('email', email, {
          path: '/',
        });

        toast.success(
          result?.message ||
            'OTP sent successfully'
        );

        // ---------------------------------------------
        // SHOW OTP / PASSWORD FIELDS
        // ---------------------------------------------

        setShowFields(true);
      } else {
        toast.error(
          result?.message ||
            result?.displayMessage ||
            'Unable to send OTP'
        );
      }
    } catch (error) {
      console.error(
        'FORGOT PASSWORD ERROR:',
        error
      );

      console.error(
        'ERROR RESPONSE:',
        error?.response?.data
      );

      toast.error(
        error?.response?.data?.message ||
          error?.response?.data?.displayMessage ||
          error?.message ||
          'Something went wrong'
      );
    } finally {
      setLoading(false);
    }
  };

  // =========================================================
  // RESET PASSWORD
  // =========================================================

  const handleResetSubmit = async () => {
    try {
      // ---------------------------------------------
      // Validate Reset Fields
      // ---------------------------------------------

      const isValid = await trigger([
        'otp',
        'newPassword',
        'confirmPassword',
      ]);

      if (!isValid) {
        return;
      }

      const values = getValues();

      const email =
        cookies?.email || '';

      if (!email) {
        toast.error(
          'Email not found. Please request OTP again.'
        );

        setShowFields(false);

        return;
      }

      setLoading(true);

      const payload = {
        email: email,
        otp: values.otp,
        newPassword: values.newPassword,
        confirmPassword:
          values.confirmPassword,
      };

      // Agar backend token expect karta hai
      // to ye automatically send ho jayega
      if (cookies?.token) {
        payload.token = cookies.token;
      }

      console.log(
        'RESET PASSWORD PAYLOAD:',
        payload
      );

      // =================================================
      // DIRECT AXIOS CALL
      // =================================================

      const response = await axios.post(
        `${ForgetUrl}/login-panel/resetPassword`,
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
            'X-localization': 'en',
          },
          timeout: 30000,
        }
      );

      console.log(
        'RESET PASSWORD RESPONSE:',
        response
      );

      const result = response?.data;

      if (result?.success || result?.status) {
        toast.success(
          result?.message ||
            'Password reset successfully'
        );

        // ---------------------------------------------
        // Clear cookies
        // ---------------------------------------------

        setCookie('token', '', {
          path: '/',
          expires: new Date(0),
        });

        setCookie('email', '', {
          path: '/',
          expires: new Date(0),
        });

        // ---------------------------------------------
        // Login page
        // ---------------------------------------------

        setTimeout(() => {
          navigate('/');
        }, 500);
      } else {
        toast.error(
          result?.message ||
            result?.displayMessage ||
            'Password reset failed'
        );
      }
    } catch (error) {
      console.error(
        'RESET PASSWORD ERROR:',
        error
      );

      console.error(
        'ERROR RESPONSE:',
        error?.response?.data
      );

      toast.error(
        error?.response?.data?.message ||
          error?.response?.data?.displayMessage ||
          error?.message ||
          'Unable to reset password'
      );
    } finally {
      setLoading(false);
    }
  };

  // =========================================================
  // RENDER
  // =========================================================

  return (
    <div>
      <main
        className="logout mt-0 ms-0"
        style={{
          overflow: 'hidden',
        }}
      >
        <section>
          <div className="page-header min-vh-75">
            <div className="container">
              <div className="row">

                {/* =================================================
                    FORM SECTION
                ================================================= */}

                <div className="col-xl-4 col-lg-5 col-md-6 d-flex flex-column mx-auto">

                  <div className="card card-plain mt-4">

                    {/* HEADER */}

                    <div className="card-header pb-0 text-left bg-transparent">

                      <Link to="/">
                        <img
                          src="/assets/img/logo1.png"
                          style={{
                            maxWidth: '120px',
                          }}
                          alt="Logo"
                        />
                      </Link>

                      <h3 className="font-weight-bolder text-info text-gradient">
                        Forgot Password
                      </h3>

                      <p className="mb-0">
                        {showFields
                          ? 'Enter OTP and create your new password'
                          : 'Enter your email to reset your password'}
                      </p>

                    </div>

                    {/* BODY */}

                    <div className="card-body">

                      {/* =================================================
                          EMAIL
                      ================================================= */}

                      <label>
                        Email Id
                      </label>

                      <div className="mb-3">

                        <input
                          type="email"
                          className={`form-control ${
                            errors.email
                              ? 'is-invalid'
                              : ''
                          }`}
                          placeholder="Enter Email Id"
                          autoComplete="email"
                          disabled={showFields || loading}
                          {...register('email', {
                            required:
                              'Email is required',

                            pattern: {
                              value:
                                /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                              message:
                                'Please enter a valid email address',
                            },
                          })}
                        />

                        {errors.email && (
                          <p className="text-danger error-msg mb-0">
                            {
                              errors.email.message
                            }
                          </p>
                        )}

                      </div>

                      {/* =================================================
                          SEND OTP BUTTON
                      ================================================= */}

                      {!showFields && (
                        <div className="text-center">

                          {/* IMPORTANT:
                              type="button"
                              NOT submit
                          */}

                          <button
                            type="button"
                            className="btn bg-gradient-info w-100 mt-4 mb-0"
                            onClick={handleForget}
                            disabled={loading}
                          >
                            {loading ? (
                              <Loader />
                            ) : (
                              'Send OTP'
                            )}
                          </button>

                        </div>
                      )}

                      {/* =================================================
                          OTP + PASSWORD
                      ================================================= */}

                      {showFields && (
                        <>

                          {/* OTP */}

                          <label>
                            OTP
                          </label>

                          <div className="mb-3">

                            <input
                              type="text"
                              className={`form-control ${
                                errors.otp
                                  ? 'is-invalid'
                                  : ''
                              }`}
                              placeholder="Enter OTP"
                              autoComplete="one-time-code"
                              disabled={loading}
                              {...register('otp', {
                                required:
                                  'OTP is required',

                                minLength: {
                                  value: 4,
                                  message:
                                    'Please enter valid OTP',
                                },
                              })}
                            />

                            {errors.otp && (
                              <p className="text-danger error-msg mb-0">
                                {
                                  errors.otp
                                    .message
                                }
                              </p>
                            )}

                          </div>

                          {/* NEW PASSWORD */}

                          <label>
                            New Password
                          </label>

                          <div className="mb-3">

                            <input
                              type="password"
                              className={`form-control ${
                                errors.newPassword
                                  ? 'is-invalid'
                                  : ''
                              }`}
                              placeholder="Enter New Password"
                              autoComplete="new-password"
                              disabled={loading}
                              {...register(
                                'newPassword',
                                {
                                  required:
                                    'New Password is required',

                                  minLength: {
                                    value: 6,
                                    message:
                                      'Password must be at least 6 characters',
                                  },
                                }
                              )}
                            />

                            {errors.newPassword && (
                              <p className="text-danger error-msg mb-0">
                                {
                                  errors
                                    .newPassword
                                    .message
                                }
                              </p>
                            )}

                          </div>

                          {/* CONFIRM PASSWORD */}

                          <label>
                            Confirm Password
                          </label>

                          <div className="mb-3">

                            <input
                              type="password"
                              className={`form-control ${
                                errors.confirmPassword
                                  ? 'is-invalid'
                                  : ''
                              }`}
                              placeholder="Confirm New Password"
                              autoComplete="new-password"
                              disabled={loading}
                              {...register(
                                'confirmPassword',
                                {
                                  required:
                                    'Confirm Password is required',

                                  validate: (
                                    value
                                  ) =>
                                    value ===
                                      newPassword ||
                                    'Passwords do not match',
                                }
                              )}
                            />

                            {errors.confirmPassword && (
                              <p className="text-danger error-msg mb-0">
                                {
                                  errors
                                    .confirmPassword
                                    .message
                                }
                              </p>
                            )}

                          </div>

                          {/* RESET BUTTON */}

                          <div className="text-center">

                            {/* IMPORTANT:
                                type="button"
                                prevents page refresh
                            */}

                            <button
                              type="button"
                              className="btn bg-gradient-info w-100 mt-4 mb-0"
                              onClick={
                                handleResetSubmit
                              }
                              disabled={loading}
                            >
                              {loading ? (
                                <Loader />
                              ) : (
                                'Reset Password'
                              )}
                            </button>

                          </div>

                          {/* CHANGE EMAIL */}

                          <div className="text-center mt-3">

                            <button
                              type="button"
                              className="btn btn-link text-info"
                              disabled={loading}
                              onClick={() => {
                                setShowFields(
                                  false
                                );
                              }}
                            >
                              Change Email
                            </button>

                          </div>

                        </>
                      )}

                    </div>
                  </div>
                </div>

                {/* =================================================
                    RIGHT IMAGE
                ================================================= */}

                <div className="col-md-6">

                  <div className="oblique position-absolute top-0 h-100 d-md-block d-none me-n8">

                    <div className="oblique-image bg-cover position-absolute fixed-top ms-auto h-100 z-index-0 ms-n6" />

                  </div>

                </div>

              </div>
            </div>
          </div>
        </section>

        <Loginfooter />
      </main>
    </div>
  );
};

export default ForgotPassword;